import React from 'react';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import AnswerTypeIcon from '@ts-core/components/AnswerTypeIcon';

import { SubjectWithStats } from 'modules/subjects/types/stats';

interface SubjectStatsListProps {
  subject?: SubjectWithStats;
  loading: boolean;
}

const SubjectStatsList = (props: SubjectStatsListProps) => {
  const { subject, loading } = props;

  if (loading) {
    <CircularProgress />;
  }

  return (
    <Box width="100%" display="flex" justifyContent="center" alignItems="flex-start" flexDirection="column">
      <Box width="100%" boxShadow={1}>
        {subject?.exercises.map((exercise, eIndex) => (
          <List
            key={exercise.id}
            subheader={
              <ListSubheader component="div" id="nested-list-subheader">
                {exercise.code}
              </ListSubheader>
            }
          >
            {exercise.questions.map((question, qIndex) => (
              <ListItem
                key={question.id}
                divider={qIndex < exercise.questions.length - 1 || eIndex < subject?.exercises.length - 1}
                sx={{
                  '&:hover': {
                    bgcolor: 'grey.100',
                  },
                }}
              >
                <ListItemText primary={question.name} />
                <ListItemSecondaryAction>
                  <AnswerTypeIcon type={question.selectedOptionType} />
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        ))}
      </Box>
    </Box>
  );
};

export default SubjectStatsList;
